export default __webpack_public_path__ + "static/bottom-banner-top-icon-9aef95b7b8d49d90e4379edfaa86aefe.png";